module.exports = __webpack_public_path__ + "img/2.d948ff2e.svg";